module.exports = __webpack_public_path__ + "img/sp_new.7f2b77c2.png";